import currencyRequest from '@Bill/mixins/currencyRequest'
import {
  getNameDescriptionTableColumn,
  getProjectDomainTableColumn,
  getTagTableColumn,
} from '@/utils/common/tableColumn'
// import i18n from '@/locales'
// import { currencyUnitMap } from '@/constants/currency'
// import { numerify } from '@/filters'

export default {
  mixins: [currencyRequest],
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        field: 'project',
        onManager: this.onManager,
        hideField: true,
        edit: false,
        editDesc: false,
        showDesc: false,
        addBackup: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.project }</side-page-trigger>
          )
        },
      }),
      getProjectDomainTableColumn({ field: 'domain' }),
      // {
      //   field: 'amount',
      //   title: i18n.t('bill.text_141'),
      //   sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.amount, '0,0.00')}`
      //   },
      // },
      // {
      //   field: 'year_amount',
      //   title: i18n.t('bill.text_139'),
      //   // sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.year_amount, '0,0.00')}`
      //   },
      // },
      getTagTableColumn({
        field: 'project_metadata',
        title: this.$t('dictionary.project_tag'),
        needExt: true,
        columns: () => this.columns,
        resource: 'projects',
        params: { service: 'identity', resource: 'projects' },
        tipName: this.$t('dictionary.project'),
        manager: new this.$Manager('projects'),
        idKey: 'tenant_id',
        vm: this,
      }),
    ]
  },
}
